module.exports = __webpack_public_path__ + "static/media/refresh.eddf732d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/refresh.svg
// module id = 787
// module chunks = 0